// import VueRecaptcha from 'vue-recaptcha';
export default {
    name: "recaptcha",
    data() {
        return {
            site_key: '6Ld3YXglAAAAABGlU_4pVXzzhMJYK7aDTvnxWeQx'
        }
    },
    components: {},
    methods: {
        onCaptchaExpired() {
            this.$refs.recaptcha.reset()
        },
        validate() {
            this.$refs.recaptcha.execute();
        },
    },
}